import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import styles from './logo_header.scss'

class LogoHeader extends PureComponent {

	render() {
		return (
			<header styleName={classNames({
				wrapper: true,
				'wrapper-border': this.props.border,
			})}>
				<h1 styleName='logo'></h1>
			</header>
		)
	}
}

LogoHeader.propTypes = {
	border: PropTypes.bool,
}

LogoHeader.defaultProps = {
	border: false,
}

export default CSSModules(LogoHeader, styles, {allowMultiple: true})
